import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputTextModule } from 'primeng/inputtext';
import { IftaLabelModule } from 'primeng/iftalabel';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { BranchesService } from '../branches.service';
import { Branch } from '../branch.model';
import { CardModule } from 'primeng/card';

@Component({
  selector: 'app-edit-branch',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    ButtonModule,
    InputGroupModule,
    InputGroupAddonModule,
    InputTextModule,
    IftaLabelModule,
    ToastModule,
    CardModule
  ],
  templateUrl: './edit-branch.component.html',
  styleUrl: './edit-branch.component.css',
  providers: [MessageService]
})
export class EditBranchComponent implements OnInit {
  branchId: number | null = null;
  branchForm!: FormGroup;
  isEditMode = false;
  pageTitle = 'Create New Branch';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private branchesService: BranchesService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      if (id) {
        this.branchId = +id;
        this.isEditMode = true;
        this.pageTitle = 'Edit Branch';
        this.loadBranchData(this.branchId); 
      }
    });
  }

  initForm(): void {
    this.branchForm = this.fb.group({
      name: ['', Validators.required],
      code: [''],
      arAccount: [''],
      apAccount: [''],
      reference: [''],
    });
  }

  loadBranchData(id: number): void {
    this.branchesService.getBranchById(id).subscribe({
      next: (branch) => this.branchForm.patchValue(branch),
      error: (err) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load branch data.' });
        console.error(err);
      }
    });
  }

  saveBranch(): void {
    if (this.branchForm.invalid) {
      this.branchForm.markAllAsTouched();
      return;
    }

    const branchData: Branch = { id: this.branchId ?? 0, ...this.branchForm.value };
    const operation = this.isEditMode
      ? this.branchesService.updateBranch(branchData)
      : this.branchesService.createBranch(branchData);

    operation.subscribe({
      next: () => {       
        this.messageService.add({ severity: 'success', summary: 'Success', detail: `Branch ${this.isEditMode ? 'updated' : 'created'} successfully.` });
        setTimeout(() => this.router.navigate(['/ai-studio/session/current', { outlets: { canvasOutlet: ['branches', 'list'] } }]), 1500);
      },
      error: (err) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: `Failed to ${this.isEditMode ? 'update' : 'create'} branch.` });
        console.error(err);
      }
    });
  }

  cancel(): void {
    this.router.navigate(['/ai-studio/session/current', { outlets: { canvasOutlet: ['branches', 'list'] } }]);
  }
}
